import { Routes } from '@angular/router';
import { userGuard } from '@core/guards';
import { PageTitleEnum } from '@shared/enums';

export const checkmateRoutes: Routes = [
    {
        path: '',
        redirectTo: 'listing',
        pathMatch: 'full',
    },
    {
        path: 'listing',
        loadComponent: () =>
            import('@features/checkmate/checkmate-listing/ckm-listing.component').then(mod => mod.CkmListingComponent),
        canActivate: [userGuard],
        title: PageTitleEnum.CHECKMATE_LISTING,
    },
    {
        path: 'details',
        loadComponent: () =>
            import('@features/checkmate/checkmate-details/checkmate-details.component').then(
                mod => mod.CheckmateDetailsComponent
            ),
        canActivate: [userGuard],
        title: PageTitleEnum.CHECKMATE_DETAILS,
    },
    {
        path: 'setup',
        loadComponent: () =>
            import('@features/checkmate/checkmate-setup/ckm-setup.component').then(mod => mod.CkmSetupComponent),
        canActivate: [userGuard],
        title: PageTitleEnum.CHECKMATE_SETUP,
    },
];
